import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Lepo",
  "description": "",
  "published": "2006-11-10T00:00:00.000Z",
  "redirect_from": ["/blog/lepo/swizec/363"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Vceraj je bilo porabljenega veliko casa za poskus nastavitve Xgl, ki je graficni server za linux in omogoca zelo fensi ucinke in mahinacije z okenskim okoljem. Omogoca v bistvu, da okolje zgleda podobno kot Mac OS X ali Aero na Visti. Res je, popapca veliko resorsov ampak je odlicen za pogledat, hotel sem pravzaprav samo malo pogledati, obljubim.`}</p>
    <p>{`Na zalost pa se je pripetilo tako, da ga nisem uspel nastaviti in tisto enkrat, ko sem celo prisel do namizja in ostalih pritiklin je bil racunalnik tako pocasen, da je bil popolnoma neuporaben. Kot bi skusal poganjati Win98 na 486ki. Za gresna kozla sta bila izbrana pocasna maticna ploca in pocasen CPU.`}</p>
    <p>{`Govoril sem z urednikom Locutia, spletne literarne revije, ki obstaja ze kar nekaj casa in ima lepo stran. Zmenila sva se, da objavi eno mojo zgodbo, ali odlomek le-te, kar je super, vendar je nekaj se bolj odlicnega. Podal je obsirno in zelo poglobljeno kritiko mojega dela, kar mi bo zelo pomagalo pri izboljsanju svojega sloga in izraznosti, ni boljsega za zacetnika kot je dobra kritika.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      